import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('internationalizedArrayStringValue', {
    value: {
        title: 'Value',
        type: 'string'
    }
});
var validator = z.object({
    value: z.string()
}).partial();
schema.internationalizedArrayStringValue;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayStringValue.js.map